import colors from '@galo-monitor/styles/colors'

export default () => ({
  variantWarning: {
    color: colors.text
  }
})
